import Widget from 'models/dashboard/widget'

Widget.TagCloudWidget = Widget.extend({
  tagIds: function () {
    return this.get('tag_ids');
  }
});

export default Widget.TagCloudWidget;


